module.exports = __webpack_public_path__ + "img/Frame 212.94607198.png";